module.exports = __webpack_public_path__ + "static/media/08.98d1f505.jpg";